var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/send"
  }, /*#__PURE__*/React.createElement("g", {
    id: "send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.50825 18.125C3.57492 18.125 2.98325 17.8083 2.60825 17.4333C1.87492 16.7 1.35825 15.1416 3.00825 11.8333L3.73325 10.3916C3.82492 10.2 3.82492 9.79996 3.73325 9.60829L3.00825 8.16662C1.34992 4.85829 1.87492 3.29162 2.60825 2.56662C3.33325 1.83329 4.89992 1.30829 8.19992 2.96662L15.3332 6.53329C17.1082 7.41662 18.0832 8.64996 18.0832 9.99996C18.0832 11.35 17.1082 12.5833 15.3416 13.4666L8.20825 17.0333C6.59158 17.8416 5.39158 18.125 4.50825 18.125ZM4.50825 3.12496C4.05825 3.12496 3.70825 3.23329 3.49158 3.44996C2.88325 4.04996 3.12492 5.60829 4.12492 7.59996L4.84992 9.04996C5.11658 9.59162 5.11658 10.4083 4.84992 10.95L4.12492 12.3916C3.12492 14.3916 2.88325 15.9416 3.49158 16.5416C4.09158 17.15 5.64992 16.9083 7.64992 15.9083L14.7832 12.3416C16.0916 11.6916 16.8332 10.8333 16.8332 9.99162C16.8332 9.14996 16.0832 8.29162 14.7749 7.64162L7.64158 4.08329C6.37492 3.44996 5.28325 3.12496 4.50825 3.12496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.03345 10.625H4.53345C4.19178 10.625 3.90845 10.3417 3.90845 10C3.90845 9.65833 4.19178 9.375 4.53345 9.375H9.03345C9.37511 9.375 9.65845 9.65833 9.65845 10C9.65845 10.3417 9.37511 10.625 9.03345 10.625Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.900c07e9ceffd1497794e322f946b322.svg";
export { ForwardRef as ReactComponent };